module.exports = __webpack_public_path__ + "static/sale.581360d1.jpg";